<ng-template #breadcrumbs>
  <ng-content select="[slot=breadcrumbs]"></ng-content>
</ng-template>

<ng-template #titleSuffix>
  <ng-content select="[slot=title-suffix]"></ng-content>
</ng-template>

<ng-template #defaultContent>
  <ng-content></ng-content>
</ng-template>

<ng-template #tabsContent>
  <ng-content select="[slot=tabs]"></ng-content>
</ng-template>

@if (vfo1Enabled()) {
  <header
    class="[&:not(bit-layout_*,bit-page_*)]:tw-mx-10 tw-mb-8 tw-flex tw-flex-col tw-gap-6 @3xl:tw-gap-8 tw-pt-8 has-[[data-tabs]:not(:empty)]:tw-border-0 has-[[data-tabs]:not(:empty)]:tw-border-b has-[[data-tabs]:not(:empty)]:tw-border-solid has-[[data-tabs]:not(:empty)]:tw-border-border-base"
  >
    <div class="tw-flex tw-flex-col @2xl:tw-flex-row tw-gap-4">
      <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-2">
        <div class="tw-flex tw-items-center tw-h-full empty:tw-hidden">
          <ng-container *ngTemplateOutlet="breadcrumbs"></ng-container>
        </div>
        @if (!hasPromotedHeading()) {
          <h1
            bitTypography="h1"
            noMargin
            class="tw-m-0 tw-leading-10 tw-flex tw-gap-1"
            [title]="title()"
          >
            <div class="tw-truncate">
              @if (icon()) {
                <bit-icon [name]="icon()" />
              }

              {{ title() }}
            </div>
            <div class="tw-flex tw-items-center">
              <ng-container *ngTemplateOutlet="titleSuffix"></ng-container>
            </div>
          </h1>
        }
        <div bitTypography="body1" class="tw-text-fg-body tw-max-w-[800px] empty:tw-hidden">
          <ng-content select="[slot=subtitle]"></ng-content>
        </div>
      </div>
      <div
        class="tw-flex tw-min-w-max tw-items-center tw-justify-start @2xl:tw-justify-end tw-gap-3 empty:tw-hidden tw-max-h-fit"
      >
        <ng-container *ngTemplateOutlet="defaultContent"></ng-container>
      </div>
    </div>
    <div data-tabs class="-tw-mb-px empty:tw-hidden">
      <ng-container *ngTemplateOutlet="tabsContent"></ng-container>
    </div>
  </header>
} @else {
  <header
    class="-tw-mt-6 -tw-mx-8 tw-mb-3 tw-flex tw-flex-col tw-gap-4 tw-py-6 tw-px-8 has-[[data-tabs]:not(:empty)]:tw-border-0 has-[[data-tabs]:not(:empty)]:tw-border-b has-[[data-tabs]:not(:empty)]:tw-border-solid has-[[data-tabs]:not(:empty)]:tw-border-secondary-100 has-[[data-tabs]:not(:empty)]:tw-bg-background-alt has-[[data-tabs]:not(:empty)]:tw-pb-0"
  >
    <div class="tw-flex">
      <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-2">
        <ng-container *ngTemplateOutlet="breadcrumbs"></ng-container>
        <h1
          bitTypography="h1"
          noMargin
          class="tw-m-0 tw-mr-2 tw-leading-10 tw-flex tw-gap-1"
          [title]="title()"
        >
          <div class="tw-truncate">
            @if (icon()) {
              <i class="bwi {{ icon() }}" aria-hidden="true"></i>
            }

            {{ title() }}
          </div>
          <div>
            <ng-container *ngTemplateOutlet="titleSuffix"></ng-container>
          </div>
        </h1>
      </div>
      <div class="tw-ml-auto tw-flex tw-flex-col tw-gap-4">
        <div class="tw-flex tw-min-w-max tw-items-center tw-justify-end tw-gap-2">
          <ng-container *ngTemplateOutlet="defaultContent"></ng-container>
        </div>
        <div class="tw-ml-auto empty:tw-hidden">
          <ng-content select="[slot=secondary]"></ng-content>
        </div>
      </div>
    </div>
    <div data-tabs class="-tw-mb-px empty:tw-hidden">
      <ng-container *ngTemplateOutlet="tabsContent"></ng-container>
    </div>
  </header>
}
